{
  "appointment-history-page": {
    "text": {
      "in-the-past": "V minulosti nebo zrušeno",
      "no-appointment": "Žádnou schůzku jste si neobjednali!",
      "upcoming": "Nadcházející schůzka"
    },
    "meta": {
      "title": "Jmenování",
      "description": "Seznam rezervovaných schůzek"
    }
  }
}
